<!--
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-02 11:52:05
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-31 11:19:28
-->
<template>
  <div class="upload-calendar">
    <div class="calendar-container">
      <div
        :class="['calendar-item', item.styleItem]"
        v-for="(item, idx) in list"
        :key="idx"
        @click="clickWeek(item)"
      >
        <div v-if="item.review_status==1" class="item-finish">
          <img src="../assets/images/v4.0/calendar_finish.png" />
        </div>
        <div class="item-top">
          <div :class="['item-corner-status', item.styleCorner]">{{item.strCorner}}</div>
        </div>
        <div class="item-content">
          <div :class="['item-content-week', item.styleWeek]">第 {{item.current_week}} 周</div>
          <div
            :class="['item-content-time', item.styleWeek]"
          >{{item.strWeekStart}}-{{item.strWeekEnd}}</div>
          <div
            :class="['item-content-deadline', item.isShowDeadline?'':'item-content-deadline-white']"
          >
            <span v-show="item.isShowDeadline">{{item.strDeadline}}点截止</span>
          </div>
          <div :class="['item-content-bottom', item.styleBottom]">{{item.strBottom}}</div>
        </div>
      </div>
    </div>
    <div class="calendar-bottom">
      <div class="calendar-bottom-title">规则说明</div>
      <p class="calendar-bottom-rule" v-for="(item, index) in rules" :key="index">{{item}}</p>
    </div>
    <review-upload-alert :isShow="isShowReviewUploadAlert" @closePopup="closeShowReviewUploadAlert"></review-upload-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import rules from '../assets/js/ruleUpload.js'
import ReviewUploadAlert from '../components/ReviewUploadAlert'
import TimeFormat from '../utils/TimeFormat' // 参数格式化
export default {
  name: 'uploadCalendar',
  components: { ReviewUploadAlert },
  computed: mapState(['uploadStatus', 'currentWeekIndex']),
  data () {
    return {
      rules: rules, // 规则
      currentWeek: 4, // 当前周
      isShowReviewUploadAlert: false,
      list: []
    }
  },
  props: {
    isShow: {
      typy: Boolean,
      default: true
    }
  },
  watch: {
    isShow (val) {
      this.show = val
    },
    show (val) {
      console.log('show----', val)
      if (!val) {
        this.$emit('closePopup')
      }
    }
  },
  created () {
    this.$xesLogger.clickMsg({
      params: {
        elementname: '日历页',
        element_action: 'show',
        element_value: '日历页-页面访问'
      }
    })
    this.getReviewStatusList()
  },
  methods: {
    // 获取审核记录列表
    getReviewStatusList () {
      this.$api
        .getReviewStatusList()
        .then(res => {
          this.currentWeek = res.data.currentWeek
          console.log('getReviewStatusList=========', res.data.currentWeek)
          this.$store.dispatch('storeCurrentWeekIndex', res.data.currentWeek)
          this.list = res.data.list
          this.processData()
        })
        .catch(() => {
          this.$xesLogger.clickMsg({
            params: {
              elementname: '日历页',
              element_action: 'click',
              element_value: '获取审核列表失败'
            }
          })
        })
    },
    // 数据处理
    processData () {
      this.list.map(item => {
        // 是否展示已结束
        if (item.review_status === 1) {
          item.isShowFinish = true
        } else {
          item.isShowFinish = false
        }
        item.isShowDeadline = false
        if (item.week_status === -1) {
          // 过去周
          if (item.fill_card === 0) {
            // 非补卡周
            this.applyDifScreen(
              item,
              'item-corner-status-gray',
              '过期',
              'item-content-week-gray',
              'item-content-bottom-gray'
            )
          } else {
            // 补卡周（默认高亮）
            this.applyDifScreen(
              item,
              'item-corner-status-gold',
              '补卡',
              'item-content-week-gold',
              'item-content-bottom-gold',
              'calendar-item-gold-border'
            )
            item.isShowDeadline = true
            if (this.isBeforeDeadline(item.deadline)) {
              // 补卡周-未过截止时间
              if (item.review_status === -1 || item.review_status === 1) {
                // 未参与，审核成功
                this.applyDifScreen(
                  item,
                  'item-corner-status-gray',
                  '过期',
                  'item-content-week-gray',
                  'item-content-bottom-gray'
                )
                item.isShowDeadline = false
              }
            } else {
              // 补卡周-已过截止时间
              if (item.review_status === -1 || item.review_status === 1) {
                // 未参与，审核成功
                this.applyDifScreen(
                  item,
                  'item-corner-status-gray',
                  '过期',
                  'item-content-week-gray',
                  'item-content-bottom-gray'
                )
                item.isShowDeadline = false
              } else if (item.review_status === 2) {
                // 审核失败
                this.applyDifScreen(
                  item,
                  'item-corner-status-gold',
                  '补卡',
                  'item-content-week-gold',
                  'item-content-bottom-gray'
                )
              }
            }
          }
        } else if (item.week_status === 0) {
          // 当周
          this.applyDifScreen(
            item,
            'item-corner-status-gold',
            '本周',
            'item-content-week-gold',
            'item-content-bottom-gold',
            'calendar-item-gold-border'
          )
        } else {
          // 未来周
          this.applyDifScreen(
            item,
            'item-corner-status-hidden',
            '',
            'item-content-week-gold',
            'item-content-bottom-white'
          )
        }
        item.strWeekStart = TimeFormat.timeToMonthDay(item.week_start)
        item.strWeekEnd = TimeFormat.timeToMonthDay(item.week_end)
        item.strDeadline = TimeFormat.timeToMonthDayHour(item.deadline)
      })
    },
    // 对应不同的场景使用不同的样式与文案
    /**
     * item:具体对象
     * styleCorner:左上角标签
     * strCorner:左上角文案
     * styleWeek:周样式
     * styleBottom:底部样式
     * strBottom:底部文案
     */
    applyDifScreen (
      item,
      styleCorner,
      strCorner,
      styleWeek,
      styleBottom,
      styleItem = ''
    ) {
      item.styleCorner = styleCorner
      item.strCorner = strCorner
      item.styleWeek = styleWeek
      item.styleBottom = styleBottom
      item.strBottom = this.getReviewDesBy(item)
      item.styleItem = styleItem
    },
    // 获取审核描述
    getReviewDesBy (item) {
      // -1：待上传 0:审核中、1：审核通过、2：审核失败
      const { review_status, week_status } = item
      const contentMap = new Map()
      contentMap.set(-1, () => {
        let content = '待上传'
        if (week_status === -1) {
          content = '未参与'
        } else if (week_status === 1) {
          content = '待开始'
        }
        return content
      })
      contentMap.set(0, '审核中')
      contentMap.set(1, '审核通过')
      contentMap.set(2, '审核失败')
      const currentText = contentMap.get(review_status)
      if (typeof currentText === 'function') {
        return currentText()
      } else {
        return currentText
      }
      // console.log(typeof contentMap.get(review_status))
      // switch (item.review_status) {
      //   case -1: {
      //     let r = "待上传";
      //     if (item.week_status === -1) {
      //       r = "未参与";
      //     } else if (item.week_status === 1) {
      //       r = "待开始";
      //     }
      //     return r;
      //   }
      //   case 0:
      //     return "审核中";
      //   case 1:
      //     return "审核通过";
      //   case 2:
      //     return "审核失败";
      //   default:
      //     return "";
      // }
    },
    clickWeek (item) {
      if (item.week_status === -1) {
        // 过去周
        if (item.fill_card === 0) {
          // 非补卡周
          console.log('点击过期----')
        } else {
          // 补卡周
          console.log('点击补卡周----', item)
          if (this.isBeforeDeadline(item.deadline)) {
            // 补卡周-未过截止时间
            if (item.review_status === 0 || item.review_status === 2) {
              // 审核中，审核失败，都可点击
              this.$store.dispatch('storeUploadStatus', item)
              this.isShowReviewUploadAlert = true
              this.$xesLogger.clickMsg({
                params: {
                  elementname: '补卡入口',
                  element_action: 'click',
                  element_value: '日历页-补卡入口-按钮点击',
                  review_status: item.review_status
                }
              })
            }
          } else {
            // 补卡周-已过截止时间
            if (item.review_status === 2) {
              // 审核失败
              this.$toast('已截止上传')
              this.$xesLogger.clickMsg({
                params: {
                  elementname: '补卡入口',
                  element_action: 'show',
                  element_value:
                    '日历页-补卡入口-已过截止时-审核失败-toast出现',
                  review_status: item.review_status
                }
              })
            } else if (item.review_status === 0) {
              // 审核中、审核成功
              this.$store.dispatch('storeUploadStatus', item)
              this.isShowReviewUploadAlert = true
            }
          }
        }
      } else if (item.week_status === 0) {
        // 当周
        console.log('点击当周----', item)
        this.$xesLogger.clickMsg({
          params: {
            elementname: '本周入口',
            element_action: 'click',
            element_value: '日历页-本周入口-按钮-点击',
            review_status: item.review_status
          }
        })
        this.$store.dispatch('storeUploadStatus', item)
        this.isShowReviewUploadAlert = true
      } else {
        // 未来周
        console.log('点击未来周----')
      }
    },
    // 是否过了截止时间
    isBeforeDeadline (deadline) {
      const timeStampNow = Date.parse(new Date()) / 1000
      if (timeStampNow < deadline) {
        return true
      }
      return false
    },
    closeShowReviewUploadAlert () {
      console.log('closeAlert-----')
      this.isShowReviewUploadAlert = false
      this.getReviewStatusList()
    }
  }
}
</script>
<style lang="less" scoped>
.upload-calendar {
  width: 100%;
  height: 100%;
  padding: 94px 0 10px;
  font-family: "PingFang SC Regular", "PingFang SC Regular-Regular";
  background: #fff7e4 url("../assets/images/v4.0/calendar_bg.png") no-repeat;
  background-size: 100%;

  .calendar-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 100%;
    padding: 0 10px 0 10px;

    .calendar-item {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 112px;
      height: auto;
      margin: 4px 2px;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 10px;

      .item-finish {
        position: absolute;
        top: 2px;
        right: 2px;
        z-index: 20;
        width: 35px;
        height: 33px;

        img {
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 100%;
        }
      }

      .item-top {
        width: 100%;
        height: 19px;
        margin-bottom: 5px;
        text-align: left;

        .item-corner-status {
          width: 41px;
          height: 19px;
          font-size: 10px;
          line-height: 19px;
          text-align: center;
          background: #e6e6e6;
          border-top-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        .item-corner-status-gray {
          color: #999;
          background-image: linear-gradient(#e6e6e6, #e6e6e6);
        }

        .item-corner-status-gold {
          color: #fff;
          background-image: linear-gradient(#ffd087, #d69937);
        }

        .item-corner-status-hidden {
          visibility: hidden;
        }
      }

      .item-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        color: #844711;

        .item-content-week-gray {
          color: #a9a9a9;
        }

        .item-content-week-gold {
          color: #844711;
        }

        .item-content-week {
          width: 100%;
          margin-bottom: 4px;
          font-size: 16px;
        }

        .item-content-time {
          width: 100%;
          font-size: 14px;
          font-weight: 400;
        }

        .item-content-deadline {
          width: 102px;
          height: 18px;
          margin-bottom: 10px;
          font-size: 10px;
          line-height: 18px;
          color: #e02727;
          background: #f8f8f8;
          border-radius: 9px;
        }

        .item-content-deadline-white {
          background: #fff;
        }

        .item-content-bottom {
          width: 100%;
          height: 30px;
          font-size: 16px;
          line-height: 30px;
          text-align: center;
          color: #fff;
          background-image: linear-gradient(#ffd087, #d69937);
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        .item-content-bottom-gray {
          color: #fff;
          background-image: linear-gradient(#ddd, #ddd);
        }

        .item-content-bottom-gold {
          color: #fff;
          background-image: linear-gradient(#ffd087, #d69937);
        }

        .item-content-bottom-white {
          color: #a9a9a9;
          background-image: linear-gradient(#f8f8f8, #f8f8f8);
        }
      }
    }

    .calendar-item-gold-border {
      border: 1px solid #fece85;
    }
  }

  .calendar-bottom {
    padding: 15px;
    text-align: left;

    .calendar-bottom-title {
      margin-bottom: 10px;
      font-size: 15px;
      color: #e02727;
    }

    .calendar-bottom-rule {
      font-size: 11px;
      font-weight: 400;
      color: #333;
    }
  }
}
</style>
